import { TextSearchIcon } from './TextSearchIcon';

/**
 * author: Austin Andrews
 * id 3C1714C4-ACE1-45F2-ADE8-D90DD2E9742C
 * name text-search
 * version: 5.1.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/text-search.svg
 * tags
 */
export const NotesSearchIcon = TextSearchIcon;
export default NotesSearchIcon